exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".UpDownVote__container___23WuF {\n    font-size: 0.8rem;\n    display: flex;\n}\n\n.UpDownVote__division___F-meX {\n    margin: 0 0.25rem;\n}\n\n.UpDownVote__text___2iv8p {\n    margin-top: 0.12rem;\n}\n", ""]);

// exports
exports.locals = {
	"container": "UpDownVote__container___23WuF",
	"division": "UpDownVote__division___F-meX",
	"text": "UpDownVote__text___2iv8p"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/UpDownVote.icss
// module id = 1346
// module chunks = 0